import { defineStore } from 'pinia'
import { ref } from 'vue'
import { parkRequest } from '@/qingyu'

// 定义提报状态存储
export const useReportStore = defineStore('report', () => {
  // 状态
  const reportList = ref([])
  const currentReport = ref(null)
  const reportDetail = ref(null)
  const reportTypes = ref([])
  const departments = ref([])
  const loading = ref(false)
  const attachmentList = ref([])
  
  // 服务列表相关状态
  const kejiServiceList = ref([])
  const jinrongServiceList = ref([])
  const shengchanServiceList = ref([])
  const activeTabName = ref('keji') // 当前选中的选项卡：keji, jinrong, shengchan
  const serviceListLoading = ref(false)
  
  // 过滤条件
  const filterParams = ref({
    status: null,
    type: null,
    departmentId: null,
    keyword: '',
    startDate: null,
    endDate: null,
    page: 1,
    pageSize: 10
  })
  
  // 分页信息
  const pagination = ref({
    total: 0,
    current: 1,
    pageSize: 10
  })
  
  // 提报状态映射
  const statusMap = {
    0: '待受理',
    1: '处理中',
    2: '已处理',
    3: '已驳回',
    4: '已取消'
  }
  
  // 提报类型列表（示例数据，实际应从API获取）
  const reportTypeOptions = ref([
    { label: '设施报修', value: 'facility' },
    { label: '投诉建议', value: 'complaint' },
    { label: '服务申请', value: 'service' },
    { label: '其他', value: 'other' }
  ])
  
  // 部门列表（示例数据，实际应从API获取）
  const departmentOptions = ref([
    { label: '物业部', value: 'property' },
    { label: '管理部', value: 'management' },
    { label: '技术部', value: 'tech' },
    { label: '行政部', value: 'admin' }
  ])
  
  // 获取提报列表
  async function getReportList(params = {}) {
    loading.value = true
    try {
      // 合并过滤参数
      const queryParams = { ...filterParams.value, ...params }
      
      // 模拟API调用
      // const response = await reportRequest.getReportList(queryParams)
      
      // 模拟数据
      const response = {
        list: [
          {
            id: '1',
            title: '会议室空调故障',
            type: 'facility',
            typeName: '设施报修',
            departmentId: 'property',
            departmentName: '物业部',
            status: 0,
            createTime: '2023-06-01 10:30:00',
            updateTime: '2023-06-01 10:30:00'
          },
          {
            id: '2',
            title: '园区环境建议',
            type: 'complaint',
            typeName: '投诉建议',
            departmentId: 'management',
            departmentName: '管理部',
            status: 1,
            createTime: '2023-06-02 14:20:00',
            updateTime: '2023-06-02 15:10:00'
          }
        ],
        total: 2,
        page: 1,
        pageSize: 10
      }
      
      reportList.value = response.list
      pagination.value = {
        total: response.total,
        current: response.page,
        pageSize: response.pageSize
      }
      
      return reportList.value
    } catch (error) {
      console.error('获取提报列表失败', error)
      return []
    } finally {
      loading.value = false
    }
  }
  
  // 获取提报详情
  async function getReportDetail(id) {
    if (!id) return null
    
    loading.value = true
    try {
      // 模拟API调用
      // const response = await reportRequest.getReportDetail(id)
      
      // 模拟数据
      const response = {
        id: '1',
        title: '会议室空调故障',
        content: '3楼会议室空调制冷效果不佳，请尽快维修',
        type: 'facility',
        typeName: '设施报修',
        departmentId: 'property',
        departmentName: '物业部',
        status: 0,
        statusHistory: [
          {
            status: 0,
            time: '2023-06-01 10:30:00',
            operator: '张三',
            remark: '提交申请'
          }
        ],
        attachments: [
          {
            id: '1',
            name: '故障照片.jpg',
            url: 'https://example.com/uploads/fault.jpg',
            size: 1024 * 1024,
            type: 'image/jpeg',
            uploadTime: '2023-06-01 10:28:00'
          }
        ],
        createTime: '2023-06-01 10:30:00',
        updateTime: '2023-06-01 10:30:00'
      }
      
      reportDetail.value = response
      attachmentList.value = response.attachments || []
      
      return reportDetail.value
    } catch (error) {
      console.error('获取提报详情失败', error)
      return null
    } finally {
      loading.value = false
    }
  }
  
  // 创建提报
  async function createReport(data) {
    loading.value = true
    try {
      // 模拟API调用
      // const response = await reportRequest.createReport(data)
      
      // 模拟响应
      const response = {
        code: 200,
        message: '提交成功',
        data: {
          id: Math.floor(Math.random() * 1000).toString()
        }
      }
      
      return response
    } catch (error) {
      console.error('创建提报失败', error)
      return {
        code: 500,
        message: '创建失败',
        data: null
      }
    } finally {
      loading.value = false
    }
  }
  
  // 取消提报
  async function cancelReport(id) {
    if (!id) return false
    
    loading.value = true
    try {
      // 模拟API调用
      // const response = await reportRequest.cancelReport(id)
      
      // 模拟响应
      const response = {
        code: 200,
        message: '取消成功'
      }
      
      // 更新本地数据
      if (reportDetail.value && reportDetail.value.id === id) {
        reportDetail.value.status = 4 // 已取消
      }
      
      const index = reportList.value.findIndex(item => item.id === id)
      if (index !== -1) {
        reportList.value[index].status = 4
      }
      
      return true
    } catch (error) {
      console.error('取消提报失败', error)
      return false
    } finally {
      loading.value = false
    }
  }
  
  // 更新过滤条件
  function updateFilterParams(params) {
    filterParams.value = { ...filterParams.value, ...params }
  }
  
  // 重置过滤条件
  function resetFilterParams() {
    filterParams.value = {
      status: null,
      type: null,
      departmentId: null,
      keyword: '',
      startDate: null,
      endDate: null,
      page: 1,
      pageSize: 10
    }
  }
  
  // 清空数据
  function resetReportState() {
    reportList.value = []
    currentReport.value = null
    reportDetail.value = null
    attachmentList.value = []
    resetFilterParams()
  }
  
  // 获取科技服务列表
  async function getKejiServiceList(params = {}) {
    serviceListLoading.value = true
    try {
      const response = await parkRequest.getKejiServiceList(params)
      // 正确处理API返回的数据结构
      if (response && Array.isArray(response.data)) {
        kejiServiceList.value = response.data
      } else if (response && typeof response === 'object') {
        // 兼容不同的API返回格式
        kejiServiceList.value = Array.isArray(response) ? response : []
      } else {
        kejiServiceList.value = []
      }
      return kejiServiceList.value
    } catch (error) {
      console.error('获取科技服务列表失败', error)
      kejiServiceList.value = []
      return []
    } finally {
      serviceListLoading.value = false
    }
  }
  
  // 获取金融服务列表
  async function getJinrongServiceList(params = {}) {
    serviceListLoading.value = true
    try {
      const response = await parkRequest.getJinrongServiceList(params)
      // 正确处理API返回的数据结构
      if (response && Array.isArray(response.data)) {
        jinrongServiceList.value = response.data
      } else if (response && typeof response === 'object') {
        // 兼容不同的API返回格式
        jinrongServiceList.value = Array.isArray(response) ? response : []
      } else {
        jinrongServiceList.value = []
      }
      return jinrongServiceList.value
    } catch (error) {
      console.error('获取金融服务列表失败', error)
      jinrongServiceList.value = []
      return []
    } finally {
      serviceListLoading.value = false
    }
  }
  
  // 获取生产服务列表
  async function getShengchanServiceList(params = {}) {
    serviceListLoading.value = true
    try {
      const response = await parkRequest.getShengchanServiceList(params)
      // 正确处理API返回的数据结构
      if (response && Array.isArray(response.data)) {
        shengchanServiceList.value = response.data
      } else if (response && typeof response === 'object') {
        // 兼容不同的API返回格式
        shengchanServiceList.value = Array.isArray(response) ? response : []
      } else {
        shengchanServiceList.value = []
      }
      return shengchanServiceList.value
    } catch (error) {
      console.error('获取生产服务列表失败', error)
      shengchanServiceList.value = []
      return []
    } finally {
      serviceListLoading.value = false
    }
  }
  
  // 切换选项卡
  function changeActiveTab(tabName) {
    activeTabName.value = tabName
  }
  
  // 添加科技服务
  async function addKejiService(data) {
    serviceListLoading.value = true
    try {
      const response = await parkRequest.addKejiService(data)
      if (response) {
        // 添加成功后刷新列表
        await getKejiServiceList()
        return { success: true, message: '添加科技服务成功' }
      }
      return { success: false, message: '添加科技服务失败' }
    } catch (error) {
      console.error('添加科技服务失败', error)
      return { success: false, message: '添加科技服务失败' }
    } finally {
      serviceListLoading.value = false
    }
  }
  
  // 添加金融服务
  async function addJinrongService(data) {
    serviceListLoading.value = true
    try {
      const response = await parkRequest.addJinrongService(data)
      if (response) {
        // 添加成功后刷新列表
        await getJinrongServiceList()
        return { success: true, message: '添加金融服务成功' }
      }
      return { success: false, message: '添加金融服务失败' }
    } catch (error) {
      console.error('添加金融服务失败', error)
      return { success: false, message: '添加金融服务失败' }
    } finally {
      serviceListLoading.value = false
    }
  }
  
  // 添加生产服务
  async function addShengchanService(data) {
    serviceListLoading.value = true
    try {
      const response = await parkRequest.addShengchanService(data)
      if (response) {
        // 添加成功后刷新列表
        await getShengchanServiceList()
        return { success: true, message: '添加生产服务成功' }
      }
      return { success: false, message: '添加生产服务失败' }
    } catch (error) {
      console.error('添加生产服务失败', error)
      return { success: false, message: '添加生产服务失败' }
    } finally {
      serviceListLoading.value = false
    }
  }

  return {
    // 状态
    reportList,
    currentReport,
    reportDetail,
    reportTypes,
    departments,
    loading,
    attachmentList,
    filterParams,
    pagination,
    statusMap,
    reportTypeOptions,
    departmentOptions,
    
    // 服务列表相关状态
    kejiServiceList,
    jinrongServiceList,
    shengchanServiceList,
    activeTabName,
    serviceListLoading,
    
    // 方法
    getReportList,
    getReportDetail,
    createReport,
    cancelReport,
    updateFilterParams,
    resetFilterParams,
    resetReportState,
    
    // 服务列表相关方法
    getKejiServiceList,
    getJinrongServiceList,
    getShengchanServiceList,
    addKejiService,
    addJinrongService,
    addShengchanService,
    changeActiveTab
  }
}, {
  persist: {
    key: 'report-store',
    storage: sessionStorage,
    paths: ['filterParams']
  }
}) 